<DataGridView DataUrl="/Backend/Api/V2/Admin/Kooperationspartner/List" #Grid KeyProperty="key">
  <DataGridViewColumn field="stammdaten.name" header="Name" />
  <DataGridViewColumn field="stammdaten.ik" header="IK" />
  <DataGridViewColumn field="stammdaten.mail" header="E-Mail" />
  <DataGridViewColumn field="stammdaten.telefone" header="Telefone" />
  <DataGridViewColumn field="stammdaten.leistungserbrinnger" header="Leistungserbrinnger" />
  <DataGridViewColumn [isFixed]="true"  [AllowOrder]="false" [AllowSearch]="false">
    <ng-template #cell let-row>
      <PopUpView icon="bi bi-pencil-fill" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-primary" header="Kooperationspartner">
        <ng-template #staticContent>
          <KooperationspartnerEdit [Key]="row?.key"></KooperationspartnerEdit>
        </ng-template>
      </PopUpView>
    </ng-template>
    <ng-template #header>
      <PopUpView icon="bi bi-plus" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-success" header="Kooperationspartner">
        <ng-template #staticContent>
          <KooperationspartnerEdit></KooperationspartnerEdit>
        </ng-template>
      </PopUpView>
    </ng-template>
  </DataGridViewColumn>
</DataGridView>
